import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::store
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:44
* @route 'https://org.proexpert.app/org/taxonomy/categories'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/taxonomy/categories',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::store
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:44
* @route 'https://org.proexpert.app/org/taxonomy/categories'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::store
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:44
* @route 'https://org.proexpert.app/org/taxonomy/categories'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::store
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:44
* @route 'https://org.proexpert.app/org/taxonomy/categories'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::store
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:44
* @route 'https://org.proexpert.app/org/taxonomy/categories'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::move
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:59
* @route 'https://org.proexpert.app/org/taxonomy/categories/{category}'
*/
export const move = (args: { category: string | number } | [category: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: move.url(args, options),
    method: 'put',
})

move.definition = {
    methods: ["put"],
    url: 'https://org.proexpert.app/org/taxonomy/categories/{category}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::move
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:59
* @route 'https://org.proexpert.app/org/taxonomy/categories/{category}'
*/
move.url = (args: { category: string | number } | [category: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { category: args }
    }

    if (Array.isArray(args)) {
        args = {
            category: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        category: args.category,
    }

    return move.definition.url
            .replace('{category}', parsedArgs.category.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::move
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:59
* @route 'https://org.proexpert.app/org/taxonomy/categories/{category}'
*/
move.put = (args: { category: string | number } | [category: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: move.url(args, options),
    method: 'put',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::move
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:59
* @route 'https://org.proexpert.app/org/taxonomy/categories/{category}'
*/
const moveForm = (args: { category: string | number } | [category: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: move.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::move
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:59
* @route 'https://org.proexpert.app/org/taxonomy/categories/{category}'
*/
moveForm.put = (args: { category: string | number } | [category: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: move.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

move.form = moveForm

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::destroy
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:71
* @route 'https://org.proexpert.app/org/taxonomy/categories/{category}'
*/
export const destroy = (args: { category: string | number } | [category: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: 'https://org.proexpert.app/org/taxonomy/categories/{category}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::destroy
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:71
* @route 'https://org.proexpert.app/org/taxonomy/categories/{category}'
*/
destroy.url = (args: { category: string | number } | [category: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { category: args }
    }

    if (Array.isArray(args)) {
        args = {
            category: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        category: args.category,
    }

    return destroy.definition.url
            .replace('{category}', parsedArgs.category.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::destroy
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:71
* @route 'https://org.proexpert.app/org/taxonomy/categories/{category}'
*/
destroy.delete = (args: { category: string | number } | [category: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::destroy
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:71
* @route 'https://org.proexpert.app/org/taxonomy/categories/{category}'
*/
const destroyForm = (args: { category: string | number } | [category: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::destroy
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:71
* @route 'https://org.proexpert.app/org/taxonomy/categories/{category}'
*/
destroyForm.delete = (args: { category: string | number } | [category: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const categories = {
    store: Object.assign(store, store),
    move: Object.assign(move, move),
    destroy: Object.assign(destroy, destroy),
}

export default categories